import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@newfront-insurance/core-ui/v2';

import type { CustomSkillRecord } from '../../../../queries/chats';

export function DeleteCustomSkillDialog({
  skill,
  isDeleting,
  onClose,
  onConfirm,
}: {
  skill: CustomSkillRecord | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={Boolean(skill)} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent className="w-[349px]">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete custom skill</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          {skill ? (
            <>
              This removes <span className="font-mono font-semibold text-[#257FFB]">/{skill.command}</span> from your
              custom skills list.
            </>
          ) : (
            ''
          )}
        </AlertDialogDescription>
        <AlertDialogFooter className="flex-row justify-end">
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction variant="dangerous" disabled={isDeleting} onClick={onConfirm}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
